export default __webpack_public_path__ + "static/dfh-pattern-allcolors-d9812e9bcea9efcefdcc44ae8139fecb.svg";